import createRoute        from '@widesk-ui/tools/createRoute';
import AdvertisementModel from '@models/website/AdvertisementModel';

const route = createRoute.splitView(
	'/configuration/advertisements',
	'website',
	'AdvertisementSplitView',
	AdvertisementModel.localize('plural'),
);
export default route;
